import * as types from '../actionTypes/lobbyist'

let defaultState = {
  lobbyists: [],
  lobbyistListItems: [],
  currentLobbyist: {},
  changesRequired: {},
  activeGridIndexes: [0]
}

const lobbyistReducer = (state = defaultState, action) => {
  if (action.type === types.GET_LOBBYISTS) {
    return {
      ...state,
      lobbyists: action.lobbyists
    }
  }
  else if (action.type === types.GET_LOBBYIST_LIST_ITEMS) {
    return {
      ...state,
      lobbyistListItems: action.lobbyistListItems
    }
  }
  else if (action.type === types.GET_LOBBYIST) {
    // if view model not loaded then create empty object so we can bind form in components to that without undefined issues
    if (!action.lobbyist) {
      action.lobbyist = {}
    }
    return {
      ...state,
      currentLobbyist: action.lobbyist
    }
  }
  else if (action.type === types.GET_CHANGES_REQUIRED) {
    // if view model not loaded then create empty object so we can bind form in components to that without undefined issues
    if (!action.changesRequired) {
      action.changesRequired = {}
    }
    return {
      ...state,
      changesRequired: action.changesRequired
    }
  }
  else if (action.type === types.ADD_ACTIVE_LOBBYIST_GRID_INDEX) {
    return {
      ...state,
      activeGridIndexes: state.activeGridIndexes.concat(action.index)
    }
  }
  else if (action.type === types.REMOVE_ACTIVE_LOBBYIST_GRID_INDEX) {
    return {
      ...state,
      activeGridIndexes: state.activeGridIndexes.filter(index => index !== action.index)
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default lobbyistReducer;


// WEBPACK FOOTER //
// ./src/reducers/lobbyist.js